<template>
  <nav class="BSCPagination">
    <!-- <div
      class="BSCPagination-nav"
      :class="typeClass"
      v-show="hasFirst && hasPrev"
      @click="first"
    >
      <BSCIcon icon="navFirst" />   //Currently desactivated
    </div> -->
    <div
      class="BSCPagination-nav"
      :class="{ typeClass, 'BSCPagination-nav--is-visible': hasPrev }"
      @click="prev"
    >
      <BSCIcon
        class="BSCPagination-nav-icon BSCPagination-nav-icon--left"
        :class="typeClass"
        icon="arrowRight"
        :fillColor="buttonColor"
      />
    </div>
    <div
      class="BSCPagination-page text is-size-6"
      :class="[`is-${type}`, { 'is-current': page.isCurrent }]"
      v-for="page in pagesInRange"
      :key="page.item"
      @click="page.click"
    >
      {{ page.number }}
    </div>
    <div
      class="BSCPagination-nav"
      :class="{ typeClass, 'BSCPagination-nav--is-visible': hasNext }"
      @click="next"
    >
      <BSCIcon
        class="BSCPagination-nav-icon"
        :class="typeClass"
        icon="arrowRight"
        :fillColor="buttonColor"
      />
    </div>
    <!-- <div
      class="BSCPagination-nav"
      :class="typeClass"
      v-show="hasLast && hasNext"
      @click="last"
    >
      <BSCIcon icon="navLast" />     //Currently desactivated
    </div> -->
  </nav>
</template>

<script>
'use strict'

import BSCIcon from './BSCIcon'

import { COLORS } from '../doc/src/consts'

export default {
  name: 'BSCPagination',
  inheritAttrs: false,
  components: {
    BSCIcon
  },
  props: {
    total: {
      type: Number,
      default: 0
    },
    hasFirst: {
      type: Boolean,
      default: false
    },
    hasLast: {
      type: Boolean,
      default: false
    },
    perPage: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 1
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      currentPage: this.value
    }
  },
  methods: {
    first() {
      this.$emit('change', 1)
      this.currentPage = 1
    },
    last() {
      this.$emit('change', this.pageCount)
      this.currentPage = this.pageCount
    },
    prev() {
      this.$emit('change', this.currentPage - 1)
      this.currentPage = this.currentPage - 1
    },
    next() {
      this.$emit('change', this.currentPage + 1)
      this.currentPage = this.currentPage + 1
    },
    changePage(nb) {
      this.$emit('change', nb)
      this.currentPage = nb
    }
  },
  computed: {
    typeClass() {
      return [`is-${this.type}`]
    },
    pageCount() {
      return Math.ceil(this.total / this.perPage)
    },
    pagesInRange() {
      const pages = []
      for (let i = 1; i <= this.pageCount; i++) {
        pages.push({
          number: i,
          isCurrent: this.currentPage === i,
          click: event => {
            if (this.currentPage === i) return
            this.changePage(i)
          }
        })
      }
      return pages
    },
    hasPrev() {
      if (this.currentPage === 1) return false
      return true
    },
    hasNext() {
      if (this.currentPage === this.pageCount) return false
      return true
    },
    buttonColor() {
      return COLORS.find(color => color.label === this.type).color
    }
  },
  watch: {
    value(newValue) {
      this.currentPage = newValue
    },
    currentPage(newCurrent) {
      if (newCurrent > this.pageCount) this.last()
      if (newCurrent < 1) this.first()
      const firstElement = this.perPage * (newCurrent - 1)
      this.$emit('range', {
        min: firstElement,
        max: firstElement + this.perPage - 1
      })
    }
  }
}
</script>
